import React, {useEffect, useState} from 'react';
import {TextField} from '@mui/material';

interface UtcDateTimePickerProps {
  value?: string;
  onChange: (newValue: string) => void;
  label?: string;
}

export const UtcDateTimePicker: React.FC<UtcDateTimePickerProps> = ({
                                                                      value,
                                                                      onChange,
                                                                      label = 'Дата и время',
                                                                    }) => {
  const [localDateTime, setLocalDateTime] = useState<string>('');

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      const localIso = new Date(date.getTime() + 0).toISOString().slice(0, 16);
      setLocalDateTime(localIso);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const localValue = e.target.value;
    setLocalDateTime(localValue);

    const localDate = new Date(localValue);
    const tzOffsetMs = localDate.getTimezoneOffset() * 60000;
    const utcDate = new Date(localDate.getTime() - tzOffsetMs);
    const isoString = utcDate.toISOString();

    onChange(isoString);
  };

  return (
    <TextField
      type="datetime-local"
      label={label}
      value={localDateTime}
      onChange={handleChange}
      InputLabelProps={{shrink: true}}
      fullWidth
    />
  );
};
